import { Injectable, inject } from '@angular/core';

import { Oauth2Service } from '@bytel/checkout';

import { MainCartService } from '@services/main-cart.service';

import { tunnelRoutes } from '@tunnel/routes';

import { Observable, of } from 'rxjs';

import { StepMock } from '../../../interfaces/mock.interface';
import { PAYMENT_MOCKS } from '../../../tunnel/payment/scoring-mocks';
import { Step } from './step';

@Injectable({
    providedIn: 'root',
})
export class PaymentStep extends Step {
    public static readonly key: string = 'payment';
    public routerLink: string = `/tunnel/${tunnelRoutes.payment}`;
    public label: string = 'Paiement';
    public ecommerceStep: string = 'Checkout - paiement';
    public next: Step;
    public hasReminder = true;
    public stepMocks: StepMock[] = PAYMENT_MOCKS;
    public icon: string = 'tri-credit-card';
    protected cartService = inject(MainCartService);
    protected oauth2Service = inject(Oauth2Service);

    constructor() {
        super();
        this.oauth2Service.updateIsConnected();
        this._isLoaded.next(true);
    }

    public canAccess(): Observable<boolean> {
        const hasAddress = this.cartService.cartModel.quotes.every(
            (quote) => quote.address.shipping && quote.address.billing,
        );
        return of(this.oauth2Service.isConnected && !!this.cartService.cartModel.cartId && hasAddress);
    }

    public canDisplay(): boolean {
        return true;
    }
}
